import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML that comes from the API (or anywhere outside our translation
 * files) before it is rendered with `dangerouslySetInnerHTML`, so a tampered
 * record cannot run script in the payment funnel. Formatting tags and links pass.
 */
export const sanitizeHtml = (html: string | null | undefined): string =>
  DOMPurify.sanitize(html ?? '', { USE_PROFILES: { html: true } });
